import { createFileRoute } from "@tanstack/react-router";
import { faqJsonLd } from "@/components/faq";
import { HomeHero } from "@/components/home/hero";
import { HomePaths } from "@/components/home/paths";
import { HomeSpecimen } from "@/components/home/specimen";
import { HomeTrust } from "@/components/home/trust";
import { HomeShareCta } from "@/components/home/share-cta";
import { HomeFaq } from "@/components/home/faq-section";
import { HOME_FAQ_ITEMS } from "@/components/home/home-faq";
import { absUrl } from "@/lib/site";

// The static PNG (see __root.tsx): the home page is what gets shared most, and it is
// the one place an image that every platform renders matters most.
const HOME_OG = absUrl("/og-default.png");

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Lone Star Tick & Alpha-Gal Risk Near You | LoneStarMap" },
      {
        name: "description",
        content:
          "Free U.S. Lone Star tick and alpha-gal awareness. Check risk by ZIP or state, get prevention steps, and know what to do after a tick bite.",
      },
      { property: "og:title", content: "Are Lone Star ticks reported where you live?" },
      {
        property: "og:description",
        content:
          "Check Lone Star tick and alpha-gal awareness near you. Free educational resource for families, pet owners, hikers, hunters, and homeowners.",
      },
      { property: "og:url", content: absUrl("/") },
      { property: "og:image", content: HOME_OG },
      { name: "twitter:title", content: "Are Lone Star ticks reported where you live?" },
      { name: "twitter:image", content: HOME_OG },
    ],
    links: [{ rel: "canonical", href: absUrl("/") }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(faqJsonLd(HOME_FAQ_ITEMS)),
      },
    ],
  }),
  component: Home,
});

/**
 * One question above the fold, three paths under it, then the map, then why any of
 * it should be believed, then the questions people actually search for.
 *
 * V1 had eleven sections. The stat band quoted a "30+ states" figure with no source
 * behind it; the education and prevention blocks restated /alpha-gal and /prevention
 * in full; the audience row was six icons saying "outdoors". They are gone rather
 * than rewritten — every one of them sat between a worried reader and their answer.
 */
function Home() {
  return (
    <>
      <HomeHero />
      <HomePaths />
      <HomeSpecimen />
      <HomeTrust />
      <HomeFaq />


      <HomeShareCta />
    </>
  );
}
